<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-sky-400 hover:text-sky-600" href="/users">Usuarios</Link>
        <span class="text-sky-400 font-medium">/</span>
        {{ form.first_name }} {{ form.last_name }}
      </h1>
      <img v-if="user.photo" class="block ml-4 w-8 h-8 rounded-full" :src="user.photo" />
    </div>
    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore"> Este usuario ha sido eliminado. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="First name" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Last name" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Password" />
          <select-input v-model="form.id_role" :error="form.errors.role" class="pb-8 pr-6 w-full lg:w-1/2" label="Rol">
            <option v-for="rol in roles" :key="rol.id" :value="rol.id">{{ rol.rol }}</option>
          </select-input>
          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" />
          <select-input v-if="showSelectTypeUser" v-model="form.id_type_user" :error="form.errors.id_type_user" class="pb-8 pr-6 w-full lg:w-1/2" label="Tipo de usuario">
            <option v-for="typeUser in typeUsers" :key="typeUser.id" :value="typeUser.id">{{ typeUser.type }}</option>
          </select-input>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!user.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Eliminar Usuario</button>
          <loading-button :loading="form.processing" class="btn-sky ml-auto" type="submit">Actualizar Usuario</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Swal from 'sweetalert2'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    user: Object,
    roles: Object,
    typeUsers: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: '',
        id_role: this.user.id_role,
        photo: null,
        id_type_user: this.user.id_type_user,
      }),
      showSelectTypeUser: true
    }
  },
  created() {
    if (this.user.id_role == 3) {
      this.showSelectTypeUser = false;
    }
  },
  watch:{
    'form.id_role': function(newVal, oldVal){
      if (newVal == 3) {
        this.showSelectTypeUser = false
        this.form.id_type_user = 3;
      } else {
        this.showSelectTypeUser = true
        this.form.id_type_user = 0;
      }
    }
  },
  methods: {
    update() {
      this.form.post(`/users/${this.user.id}`, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      Swal.fire({
        title: 'Eliminar Usuario',
        text: '¿Deseas eliminar a este usuario?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Eliminar!',
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Eliminado!',
            text: 'El usuario ha sido eliminado.',
            icon: 'success',
          })
          this.$inertia.delete(`/users/${this.user.id}`)
        }
      })
    },
    restore() {
      Swal.fire({
        title: 'Restaurar Usuario',
        text: '¿Deseas restaurar a este usuario?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Eliminar!',
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Restaurado!',
            text: 'El usuario ha sido restaurado.',
            icon: 'success',
          })
          this.$inertia.put(`/users/${this.user.id}/restore`)
        }
      })
    },
  },
}
</script>
